module.exports = __webpack_public_path__ + "../../static/vue/img/FavOff.fd5cbeae.png";